<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/cases"></ion-back-button>
    </ion-buttons>
    <ion-title>Case Details</ion-title>
    <ion-buttons slot="primary">
      <ion-button fill="clear" (click)="ViewComments(selectedCase.id, selectedCase.userid)">
        <ion-icon name="chatbubble" style="font-size: 28px"></ion-icon>
        <ion-text style="font-size: 20px">{{ commentsCount }} </ion-text>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content color="lightmimbo">
  <div class="ion-padding ion-text-center" *ngIf="isLoading">
    <ion-spinner color="primary"></ion-spinner>
  </div>
  <div *ngIf="!isLoading">
    <ion-grid>
      <ion-row>
        <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
          <div class="type">
            <ion-text>{{ caseType }}</ion-text>
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
          <swiper-container pagination="true" [zoom]="true" class="header-image">
            <swiper-slide *ngFor="let image of selectedCase.images"><img [src]="image.url"
                style="width: 100%" /></swiper-slide>
          </swiper-container>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
          <a [href]="'tel:'+ selectedCase.phoneCode + selectedCase.phoneNumber"><ion-button shape="round"><ion-icon
                name="call-outline" slot="start"></ion-icon>Call</ion-button></a>
          <a [href]="'mailto:' + selectedCase.email"><ion-button shape="round"><ion-icon name="mail-outline"
                slot="start"></ion-icon>Email</ion-button></a>

          <ion-button color="primary" (click)="shareCase()" shape="round"><ion-icon name="share-social-outline"
              slot="start"></ion-icon>Share
          </ion-button>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
          <ion-text class="subtitle"> <b>Contact Information</b> </ion-text>
          <div class="info">
            <ion-text>Name: {{ selectedCase.fullName }}</ion-text>
            <br />
            <ion-text>
              Phone: {{ selectedCase.phoneCode + " " + selectedCase.phoneNumber
              }}</ion-text>
            <br />
            <ion-text>Email: {{ selectedCase.email }}</ion-text>
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
          <ion-text class="subtitle"> <b>Region/Location</b> </ion-text>
          <div class="info">
            <ion-icon name="location-outline"></ion-icon>{{
            selectedCase.location }}
          </div>
        </ion-col>
      </ion-row>
      <ion-row><ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
          <ion-text class="subtitle"> <b>Case Information</b> </ion-text>
          <div class="info">
            <ion-text>{{ selectedCase.details }}</ion-text>
          </div>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
          <ion-text class="subtitle"> <b> Identifying Details</b> </ion-text>
          <div class="info capitalize">
            <ion-text>
              Name: {{ selectedCase.dogName ? selectedCase.dogName : "Unknown"
              }}</ion-text><br />
            <ion-text>
              Breed: {{ selectedCase.breed ? selectedCase.breed : "Unknown"
              }}</ion-text><br />
            <ion-text>
              Age (Years): {{ selectedCase.age ? selectedCase.age : "Unknown"
              }}</ion-text><br />
            <ion-text> Size: {{ selectedCase.size }}</ion-text><br />
            <ion-text> Gender: {{ selectedCase.gender }}</ion-text><br />
            <ion-text> Medical Issues: {{ selectedCase.medical }}</ion-text><br />
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>